import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as SkuSearchFeature from './sku-search.reducer';
import { SkuSearchEffects } from './sku-search.effects';
import * as SkuSearchSortByFeature from './sort-by/sort-by.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(SkuSearchSortByFeature.sortOptionsByPageFeature.name, SkuSearchSortByFeature.sortOptionsByPageFeature.reducer),
        StoreModule.forFeature(SkuSearchFeature.skuSearchFeature.name, SkuSearchFeature.skuSearchFeature.reducer),
        EffectsModule.forFeature([SkuSearchEffects]),
    ],
})
export class SharedStateSkuSearchModule {}
